import { Card, Col, Row } from "react-bootstrap";
import { COLOR_PRIMARY } from "../../../../constants/Colors";
const COLOR = "rgba(255, 255, 255, 0.8)";
const MapInfoWindow = ({ index, total, speed, date, distance, onClose }) => (
  <Card
    className="shadow-6dp aligned-raleway"
    style={{
      backgroundColor: COLOR,
      position: "absolute",
      borderRadius: "10px",
      transform: "translateX(-50%)",
      bottom: 0,
      width: "220px",
    }}
  >
    <Card.Body className="p-3">
      <div
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          cursor: "pointer",
          fontWeight: 600,
          color: COLOR_PRIMARY,
          padding: "5px 10px 5px 5px",
        }}
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
      >
        X
      </div>
      <Row className="mb-1">
        <Col xs={4} className="pr-0">
          <strong>Posición:</strong>
        </Col>
        <Col xs={8}>
          {index}/{total}
        </Col>
      </Row>
      <Row className="mb-1">
        <Col xs={4} className="pr-0">
          <strong>Velocidad:</strong>
        </Col>
        <Col xs={8}>{speed} km/h</Col>
      </Row>
      <Row className="mb-1">
        <Col xs={4} className="pr-0">
          <strong>Fecha:</strong>
        </Col>
        <Col xs={8}>{date}</Col>
      </Row>
      <Row>
        <Col xs={4} className="pr-0">
          <strong>Precisión:</strong>
        </Col>
        <Col xs={8}>{distance}</Col>
      </Row>
      <div
        style={{
          position: "absolute",
          color: COLOR,
          bottom: "-6px",
          left: "50%",
          transform: "translateX(-50%)",
          width: 0,
          height: 0,
          borderLeft: "6px solid transparent",
          borderRight: "6px solid transparent",
          borderTop: "6px solid " + COLOR,
        }}
      />
    </Card.Body>
  </Card>
);

export default MapInfoWindow;
